module.exports = __webpack_public_path__ + "img/card4.f175fdfc.jpg";